import Reveal from "../components/Reveal";
import DemoPlayer from "../components/DemoPlayer";
import { Link } from "react-router-dom";
import { ArrowRight, Play } from "lucide-react";
import { trackProductTourClick } from "../hooks/useMarketingAnalytics";
import { useRef } from "react";
import AppStoreBadge from "../components/AppStoreBadge";

// Add MP4/WebM sources here once the demo video is produced.
const DEMO_SOURCES = [];

export default function DemoSection() {
  const playerRef = useRef(null);
  const openPlayer = () => {
    const trigger = playerRef.current?.querySelector(
      '[data-testid="demo-player-poster"]'
    );
    if (trigger) trigger.click();
  };

  return (
    <section
      data-testid="demo-section"
      className="py-24 lg:py-32 relative overflow-hidden"
      style={{
        background:
          "radial-gradient(1000px 500px at 80% 0%, rgba(51,78,104,0.10) 0%, rgba(51,78,104,0) 60%), radial-gradient(700px 400px at 10% 100%, rgba(232,113,44,0.08) 0%, rgba(232,113,44,0) 60%), #FAF7F2",
      }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-3xl mb-12 lg:mb-14">
          <div className="text-[13px] font-semibold uppercase tracking-[0.16em] text-[#334E68] mb-3">
            See ClientDesk VA in action
          </div>
          <h2 className="font-display font-extrabold text-[34px] sm:text-[46px] leading-[1.05] tracking-[-0.02em] text-[#1A2A3A] mb-5">
            From new client to paid invoice — in one workspace.
          </h2>
          <p className="text-[17px] text-[#57534E] leading-relaxed max-w-2xl">
            See how ClientDesk VA brings your clients, bookings, forms,
            contracts, invoices, and daily work together in one organized
            workspace.
          </p>
        </Reveal>

        <Reveal delay={100}>
          <div ref={playerRef}>
            <DemoPlayer
              poster="/appstore_ipad_01_dashboard.png"
              posterAlt="ClientDesk VA dashboard showing active clients, today's appointments, open tasks, and outstanding invoices."
              sources={DEMO_SOURCES}
              duration={75}
            />
          </div>
        </Reveal>

        <Reveal delay={180} className="mt-10">
          <div className="flex flex-wrap items-center gap-3">
            {DEMO_SOURCES.length > 0 ? (
              <button
                type="button"
                onClick={openPlayer}
                data-testid="demo-section-watch-cta"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#E8712C] hover:bg-[#C55A1F] text-white text-[15px] font-semibold transition-colors shadow-[0_10px_25px_-10px_rgba(232,113,44,0.6)]"
              >
                <Play size={16} strokeWidth={0} fill="currentColor" />
                Watch the 75-Second Demo
              </button>
            ) : (
              <AppStoreBadge source="demo_section" />
            )}
            <Link
              to="/product-tour"
              data-testid="demo-section-product-tour"
              onClick={() => trackProductTourClick("demo_section")}
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-white hover:bg-white border border-[#334E68] text-[#334E68] hover:text-[#1B2C3F] hover:border-[#1B2C3F] text-[15px] font-semibold transition-colors"
            >
              Explore ClientDesk VA <ArrowRight size={16} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
